/** @format */

const emailProviders = require("../../data/emailProviders");
const remoteConfig = require("./remote");

module.exports = {
  partnerId: "speedycasino",
  partnerName: "Simple Casino",
  country: null,
  fallbackCountry: "CA",
  restrictedCountries: [
    "DE",
    "NL",
    "AR",
    "IE",
    "RO",
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "AQ",
    "IO",
    "VG",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CK",
    "CR",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "CD",
    "DK",
    "DJ",
    "DM",
    "DO",
    "TL",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FJ",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "HN",
    "HK",
    "HU",
    "GB",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IM",
    "IL",
    "IT",
    "CI",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MH",
    "MQ",
    "MR",
    "MU",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NC",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "KP",
    "MP",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "GS",
    "KR",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "VI",
    "UG",
    "UA",
    "AE",
    "US",
    "UY",
    "UZ",
    "VU",
    "VA",
    "VE",
    "VN",
    "WF",
    "YE",
    "ZM",
  ],
  featuredCountries: [
    "IS",
    "DE",
    "FI",
    "NO",
    "CA",
    "LI",
    "BR",
    "NZ",
    "MT",
    "ZA",
  ],
  languages: [
    "en",
    "sv",
    "de",
    "fi",
    "no",
    "po",
    "ja",
    "nl",
    "fr",
    "es",
    "it",
    "da",
    "tr",
  ],
  oneInputAddressCountries: [
    "AE",
    "VN",
    "RO",
    "IN",
    "CN",
    "MT",
    "IE",
    "RU",
    "UA",
  ],
  ibanCountries: [], // List of IBAN countries to check
  language: null,
  selectableCurrencies: ["sek", "eur"], // ['currency'] - not releated by countries, [{id:'usd', countries: ['ca']}] - related to countries
  fallbackLanguage: "en-GB",
  hidePasswordByDefault: ["desktop"], // accept ['mobile','desktop'] or false
  loginRedirectURL: "/login",
  loginRedirectOnOverview: false,
  forceMobileOTPDeliveryMethod: "", // Accepts a String OR an Object | String (apply to all countries) - accepts MOBILE=sms or DISPLAY=flash-sms, if nothing is set, it'll fallback to global api settings | Object (apply to specific countries) - accepts Country code and Otp delivery type - {C1 : 'MOBILE', C2: 'DISPLAY' }
  defaultGeoIPService: "regily",
  passwordRules: {
    minLength: 8,
    maxLength: 99,
    letters: true,
    letterCasing: false,
    digits: true,
    specials: true,
    digitsOrSpecials: false, // if we want either digits or specials and not both
    restrictedProperties: [], // [Takes effect if "password-warning" screen is present only]. Properties to restrict from the password, accepts ['email', 'name', 'username','birthdate'], if nothing is set, it defaults to ALL.
    customConfig: {
      mode: false, // set to 'flexible' to enable
      criteria: ["lowercase", "uppercase", "digit", "special"],
      minimumMatchingCriteria: 3, // minimum criteria that the password must match
      validateEmail: false,
    },
  },
  fullNameRegExp: /[^a-zA-Zａ-ｚＡ-ＺÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\u{3040}-\u{30ff}\u{3400}-\u{4dbf}\u{4e00}-\u{9fff}\u{f900}-\u{faff}\u{ff66}-\u{ff9f}\u{0400}-\u{04FF}\s]/gu,
  animateOverview: true,
  animateOverviewAutoStart: true,
  animateSelectors: true,
  minimumBirthAge: { default: 18, CA: 19 }, // {default: 18} - default value of minimum birth age. {COUNTRY: VALUE} - for specific country value
  allowBackFromFirstScreen: false,
  mobileCountryPrefixSettings: {
    // options: [],
    mode: "all",
    /**
     * Above accepts values:
     *  - 'all' [default and fallback]: Country and Mobile number can be from different countries, and all prefixes are allowed
     *  - 'one': Country and Mobile number have to be from the same country, and no prefix edit option
     *  - 'restrict': restrict the countries in the options property from the prefixes list
     *  - 'allow': allow only the countries in the options property to be shown in the prefixes list
     */
  },
  allowFourDigitYear: true,
  waitForCallback: [],
  socialMedia: {
    enabled: false,
    allowOnlyLoggedIn: false, // Allow only user who are already logged in to a service; Support: Facebook only
    facebookAppId: "1940626266248961",
    googleId:
      "485912056311-pdk2vl5uis0a7cvp4ep5p6f7fuuffkl2.apps.googleusercontent.com",
    linkedInId: "7803pkog06nlor",
  },
  googleAutocompleteKey: "AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc", // set this to 'AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc' or another google places API key to enable places autocomplete or false to disable
  showRegilyBadge: false,
  dataTransformSchema: "SpeedyCasino",
  recaptcha: {
    enabled: false,
    options: {
      // https://developers.google.com/recaptcha/docs/display#explicit_render
      // Supported in config: sitekey, theme, size, tabindex
      sitekey: "6Lf9sGMUAAAAAMLxZbaNoh0JhK7vKAkXP6R0Q-Pl",
    },
  },
  sanctionsLookup: {
    enabled: false,
  },
  sentry: {
    dsn: "https://c8457ca5c4c64048b6cbbe233cea5fda@sentry.io/1388048",
  },
  enableRegilyAnalyzer: false,
  allowDataLookup: true,
  useDynamicCopy: false,
  useDynamicCopyFromOwnSubDomain: false,
  allowIncorrectEmail: true, // true to show the "it's correct" button on email validation
  externalLinks: {
    enabled: true, // used to prevent issues on gradual release
  },
  remoteConfig,
  alertBar: {
    enabled: false,
    countries: true, // Accepts boolean or an array list of allowed countries
    openLinkInExternal: false, // true to open links in new tab
    enableCollapsing: false, // allow to toggle alert content
  },
  noDataPersistenceCountries: [], // to disable prefilling inputs (credentials, user...etc) based on previously entered values stored in the sessionStorage
  noPersonalDataLookupCountries: [], // to disabled the address, name & gender lookup/prefilling
  noSpecificContentCountries: [], // to hide the hint for the phone number, country selection on the postal code screen, disable don't remember flow, disable phone validation and disable postal code masking
  blockPostalCodes: false, // can also be set in customData by value `blockPostalCodes`
  // if we want to block other than postal codes in blockedPostals.js we can add `blockedPostalCodes` to custom data, and this will overwrite default postal codes
  hideSHProvince: false, // can also be set in customData by value `hideSHProvince`
  enableEmailSuggestion: false,
  suggestionsProvider: {
    enabled: true,
    providers: emailProviders,
  },
  tooltip: {
    enabled: true,
  },
  otpProvider: {
    default: [], // set which provider to use by country for each sending attempt, each item in the array represent which provider to use for the corresponding attempt, e.i: ['attemp1' => otp1,'attemp2' => otp2....]
  },
  findClosestStreet: false,
  emailPath: "/chapter1/email",
  loginRedirectURLRemote: "#",
};



// WEBPACK FOOTER //
// ./src/partners/config/settings.js